import styled from "styled-components";
import { GrayColors, SolutionColorVariables } from "@smartsuite/types";

export const StyledWrapper = styled.div<{ isExpanded: boolean }>`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 8px;
  background-color: ${GrayColors["G-0-5"]};
  transition: background-color 200ms ease-in;

  ${(props) =>
    !props.isExpanded &&
    `
      &:hover {
        background-color: ${GrayColors["G-1"]};

        .icon {
          fill: ${SolutionColorVariables.sc1};
        }
      }
  `}

  &:not(:last-child) {
    margin-bottom: 6px;
  }
`;

export const StyledTitle = styled.div`
  cursor: pointer;
  padding: 0 10px;
  height: 40px;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const StyledArrow = styled.div<{ isExpanded: boolean }>`
  margin-right: 10px;

  transform: rotate(${(props) => (props.isExpanded ? "-180" : "-90")}deg);
  display: flex;
`;

export const StyledChildren = styled.div`
  padding-left: 36px;
  padding-bottom: 5px;
  padding-right: 10px;
  display: flex;
  flex-direction: column;
`;
